import cookie from 'react-cookies';

export const getAllCookies = () => cookie.loadAll();

export const selectCookies = (regex: any) =>
  cookie.select(regex);

export const getCookie = (key: string) => cookie.load(key);

export const setCookie = (
  key: any,
  value: any,
  options = { path: '/', secure: true },
) => cookie.save(key, value, options);

export const removeCookie = (
  key: any,
  options = { path: '/' },
) => cookie.remove(key, options);
